<template>
<div class="timePicker_box2">
    <div @click.stop="showHourF=!showHourF,showHourT=false,showMinuteF=false,showMinuteT=false" class="time_selectBox">
        <div class="bor-btm">{{hourF}}</div>
        <transition name="el-zoom-in-top">
            <ul class="time_selectMsg_Box" id="top1" v-show="showHourF">
                <li v-for="(item,i) in hourList" :key="i" @click="changeHourF(item)">
                    {{item}}
                </li>
            </ul>
        </transition>
    </div>
    <div style="margin:0 20px;font-size: 18px;font-weight:600;color:var(--text-color);">:</div>
    <div @click.stop="showMinuteF=!showMinuteF,showHourT=false,showHourF=false,showMinuteT=false" class="time_selectBox">
        <div class="bor-btm">{{minuteF}}</div>
        <transition name="el-zoom-in-top">
            <ul class="time_selectMsg_Box" id="top2" v-show="showMinuteF">
                <li v-for="(item,i) in openingMinuteList" :key="i" @click="changeMinuteF(item)">
                    {{item}}
                </li>
            </ul>
        </transition>
    </div>
    <div @click="aF='am', add()" style="margin:0 20px;font-size:16px;font-weight:600;color:#646a76;cursor:pointer" :class="{'check':aF=='am'}">am</div>
    <div @click="aF='pm', add()" style="font-size:16px;font-weight:600;color:#646a76;cursor:pointer" :class="{'check':aF=='pm'}">pm</div>

    <span class="time_picker_line"></span>

    <div @click.stop="showHourT=!showHourT,showHourF=false,showMinuteF=false,showMinuteT=false" class="time_selectBox">
        <div class="bor-btm">{{hourT}}</div>
        <transition name="el-zoom-in-top">
            <ul class="time_selectMsg_Box" id="top3" v-show="showHourT">
                <li v-for="(item,i) in hourList" :key="i" @click="changeHourT(item)">
                    {{item}}
                </li>
            </ul>
        </transition>
    </div>
    <div style="margin:0 20px;font-size: 18px;font-weight:600;color:var(--text-color);">:</div>
    <div @click.stop="showMinuteT=!showMinuteT,showHourF=false,showMinuteF=false,showHourT=false" class="time_selectBox">
        <div class="bor-btm">{{minuteT}}</div>
        <transition name="el-zoom-in-top">
            <ul class="time_selectMsg_Box" id="top4" v-show="showMinuteT">
                <li v-for="(item,i) in minuteList" :key="i" @click="changeMinuteT(item)">
                    {{item}}
                </li>
            </ul>
        </transition>
    </div>
    <div @click="tF='am', add()" style="margin:0 20px;font-size:16px;font-weight:600;color:#646a76;cursor:pointer" :class="{'check':tF=='am'}">am</div>
    <div @click="tF='pm', add()" style="font-size:16px;font-weight:600;color:#646a76;cursor:pointer" :class="{'check':tF=='pm'}">pm</div>
</div>
</template>

<script>
export default {
    props: {
        index:{
            type: Number,
            default: () => {
                return 0;
            }
        },
        week:{
            type: String,
            default: () => {
                return '';
            }
        }
  },
  data () {
    return {
        showTwo:1,
        showHourF:false,
        showHourT:false,
        showMinuteF:false,
        showMinuteT:false,
        hourF: this.index === 0 ? '09' : '',
        minuteF: this.index === 0 ? '00' : '',
        aF:'am',
        tF: this.index === 0 ? 'pm' : 'am',
        hourT:  this.index === 0 ? '06' : '',
        minuteT: this.index === 0 ? '00' : '',
        hourList:['01','02','03','04','05','06','07','08','09','10','11','12'],
        openingMinuteList: ['00', '30'],
        minuteList:[]
    }
  },
  methods: {
        changeHourF(val){
            this.hourF=val
            this.add()
        },
        changeHourT(val){
            this.hourT=val
            this.add()
        },
        changeMinuteF(val){
            this.minuteF=val
            this.add()
        },
        changeMinuteT(val){
            this.minuteT=val
            this.add()
        },
        close(){
            this.$emit('cancel')
        },
        add(){
            if(!this.hourF||!this.minuteF||!this.hourT||!this.minuteT){
                // this.$message.error('Please select time !')
                return
            }
            const start = `${this.aF=='am'?(this.hourF!=12?this.hourF:Number(this.hourF)-12):(this.hourF==12?this.hourF:Number(this.hourF)+12)}:${this.minuteF}`
            const end = `${this.tF=='am'?(this.hourT!=12?this.hourT:Number(this.hourT)-12):(this.hourT==12?this.hourT:Number(this.hourT)+12)}:${this.minuteT}`
            if(!Utils.timeToCompare(start,end,'end')){ // 结束时间大于开始时间
                this.$message.error('The end time cannot be less than the start time')
                return
            }
            let time=`${this.hourF}:${this.minuteF} ${this.aF} - ${this.hourT}:${this.minuteT} ${this.tF}`
            this.$emit('add',time, this.index, this.week)
            /*this.hourF=''
            this.hourT=''
            this.minuteF=''
            this.minuteT=''
            this.aF='am'
            this.tF='am'*/
   },
  },
  mounted() {
    let key = 0
    while (key<60) {
        if(key<10){
            this.minuteList.push(`0${key}`)
        }else{
            this.minuteList.push(key)
        }
        key++;
    }
  }
}
</script>

<style lang="scss" scoped>
.timePicker_box2{
    position: relative;
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    .time_selectBox{
        width: 50px;
        height: 40px;
        position: relative;
        .bor-btm{
            width: 50px;
            height: 40px;
            border-bottom: 2px solid var(--text-color);
            background: var(--background-color-3);
            text-align: center;
            color: var(--text-color);
            line-height: 40px;
            font-size:16px;
            font-weight: 600;
            cursor: pointer;
        }
        .time_selectMsg_Box{
            position: absolute;
            width: 100%;
            top: 50px;
            max-height: 200px;
            overflow-y: auto;
            background:var(--background-color-3);
            border-radius: 3px;
            cursor: pointer;
            text-align: center;
            color: var(--text-color);
            line-height: 40px;
            font-size:16px;
            font-weight: 600;
            z-index: 2;
            &::-webkit-scrollbar {
                display: none; /* Chrome Safari */
            }
        }
    }
    .time_picker_line{
        width: 20px;
        height: 2px;
        background-color: var(--text-color);;
        margin: 0 60px;
    }
}
.check{
    color: var(--text-color) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/timeselect.vue